<template>
  <div class="captcha">
    <vue-recaptcha :sitekey="siteKey" :load-recaptcha-script="true" @verify="handleSuccess" @error="handleError"></vue-recaptcha>
  </div>
</template>
<script>
import { VueRecaptcha } from 'vue-recaptcha'
export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      siteKey: '6Lenb1csAAAAAPxOqxJWgqiVowc9wv2FB6jNty7L'
    }
  },
  methods: {
    handleSuccess(token) {
      this.$emit('success', token)
    },
    handleError() {}
  }
}
</script>
